var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shopping_cart"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_102_283",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 50,
    height: 50,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_102_283)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shopping_cart_2",
    d: "M14.5833 45.8334C13.4375 45.8334 12.4566 45.4254 11.6406 44.6095C10.8247 43.7935 10.4167 42.8126 10.4167 41.6668C10.4167 40.5209 10.8247 39.54 11.6406 38.724C12.4566 37.9081 13.4375 37.5001 14.5833 37.5001C15.7292 37.5001 16.7101 37.9081 17.5261 38.724C18.342 39.54 18.75 40.5209 18.75 41.6668C18.75 42.8126 18.342 43.7935 17.5261 44.6095C16.7101 45.4254 15.7292 45.8334 14.5833 45.8334ZM35.4167 45.8334C34.2708 45.8334 33.2899 45.4254 32.474 44.6095C31.658 43.7935 31.25 42.8126 31.25 41.6668C31.25 40.5209 31.658 39.54 32.474 38.724C33.2899 37.9081 34.2708 37.5001 35.4167 37.5001C36.5625 37.5001 37.5434 37.9081 38.3594 38.724C39.1754 39.54 39.5833 40.5209 39.5833 41.6668C39.5833 42.8126 39.1754 43.7935 38.3594 44.6095C37.5434 45.4254 36.5625 45.8334 35.4167 45.8334ZM12.8125 12.5001L17.8125 22.9167H32.3958L38.125 12.5001H12.8125ZM10.8333 8.33342H41.5625C42.3611 8.33342 42.9688 8.68932 43.3854 9.40112C43.8021 10.1129 43.8195 10.8334 43.4375 11.5626L36.0417 24.8959C35.6597 25.5904 35.1476 26.1286 34.5052 26.5105C33.8629 26.8924 33.1597 27.0834 32.3958 27.0834H16.875L14.5833 31.2501H39.5833V35.4167H14.5833C13.0208 35.4167 11.8403 34.731 11.0417 33.3595C10.2431 31.9879 10.2083 30.6251 10.9375 29.2709L13.75 24.1667L6.25001 8.33342H2.08334V4.16675H8.85418L10.8333 8.33342Z",
    fill: "#F57423"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping_cart.adad08cf226db9e7d58f17488b7fb42b.svg";
export { ForwardRef as ReactComponent };